(function () {
  function postJSON(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  async function addVariant(vid) {
    await postJSON("/cart/add.js", { items: [{ id: Number(vid), quantity: 1 }] });
  }

  async function removeVariant(vid) {
    const cart = await fetch("/cart.js").then((r) => r.json());
    const line = cart.items.find((i) => i.variant_id === Number(vid));
    if (!line) return;
    await postJSON("/cart/change.js", { id: line.key, quantity: 0 });
  }

  function refreshCartUI() {
    // Dawn cart drawer usually refreshes on reload reliably.
    // Keeping it simple + stable.
    window.location.reload();
  }

  function init(root) {
    // Toggle add-ons
    root.querySelectorAll(".ayah-addon-toggle").forEach((toggle) => {
      toggle.addEventListener("change", async () => {
        const vid = toggle.dataset.vid;
        try {
          toggle.disabled = true;
          if (toggle.checked) await addVariant(vid);
          else await removeVariant(vid);
        } finally {
          toggle.disabled = false;
        }
        refreshCartUI();
      });
    });

    // Gift message show/hide + save to cart attributes
    const msgToggle = root.querySelector('[data-message-toggle]');
    const msgBox = root.querySelector(".ayah-giftmsg");
    if (msgToggle && msgBox) {
      msgToggle.addEventListener("change", () => {
        msgBox.hidden = !msgToggle.checked;
      });

      const saveBtn = msgBox.querySelector(".ayah-giftmsg__save");
      const textarea = msgBox.querySelector("#AyahGiftMessage");
      saveBtn.addEventListener("click", async () => {
        saveBtn.disabled = true;
        await postJSON("/cart/update.js", { attributes: { gift_message: textarea.value } });
        saveBtn.disabled = false;
      });
    }

    // Tooltip
    root.querySelectorAll(".ayah-tooltip").forEach((btn) => {
      btn.addEventListener("click", () => {
        const contentEl = btn.parentElement.querySelector(".ayah-tooltip__content");
        const text = contentEl ? contentEl.textContent.trim() : "";
        if (!text) return;

        // Remove existing
        const existing = document.querySelector(".ayah-tooltip-pop");
        if (existing) existing.remove();

        const pop = document.createElement("div");
        pop.className = "ayah-tooltip-pop";
        pop.textContent = text;
        document.body.appendChild(pop);

        const rect = btn.getBoundingClientRect();
        pop.style.left = Math.min(rect.left, window.innerWidth - pop.offsetWidth - 12) + "px";
        pop.style.top = (rect.bottom + 10) + "px";

        const close = (e) => {
          if (!pop.contains(e.target) && e.target !== btn) {
            pop.remove();
            document.removeEventListener("click", close);
            document.removeEventListener("scroll", close, true);
          }
        };
        setTimeout(() => {
          document.addEventListener("click", close);
          document.addEventListener("scroll", close, true);
        }, 0);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".ayah-addons").forEach(init);
  });
})();
